import React, { useState } from "react";
import TestiOnline from "../moduliArticolo/TestiOnline";

const SECTIONS = [
  { id: "prestashop-vig", label: "Prestashop Viglietti" },
  { id: "prestashop-bot", label: "Prestashop Bottero" },
  { id: "moda", label: "Dati Moda" },
  { id: "tecnici-web", label: "Dati tecnici web" },
];

const renderObjectValue = (value) => {
  if (value !== null && typeof value === "object") {
    return (
      <pre className="pa2 br2 mt1 overflow-auto sfondoColChiaro">
        {JSON.stringify(value, null, 2)}
      </pre>
    );
  }
  return <p className="ma0 mt1">{value ?? "N/A"}</p>;
};

const DataList = ({ data, loading, error, emptyMessage, formatLabel, formatValue, hiddenKeys }) => {
  if (loading) return <p>Caricamento dati...</p>;
  if (error) return <p className="dark-red">Errore: {error}</p>;
  if (!data) return <p>{emptyMessage}</p>;

  return (
    <div>
      {Object.entries(data)
        .filter(([key]) => !hiddenKeys?.has(key.toLowerCase()))
        .map(([key, value]) => {
          const label = formatLabel ? formatLabel(key) : key;
          const normalizedValue =
            formatValue && (value === null || typeof value !== "object")
              ? formatValue(key.toLowerCase(), value)
              : value;
          return (
            <div key={key} className="mb3 pb2 bb bordoColAlt">
              <p className="ma0 b">{label}</p>
              {renderObjectValue(normalizedValue)}
            </div>
          );
        })}
    </div>
  );
};

function DatiAltrove({
  prestashopOnline,
  prestashopOnlineLoading,
  prestashopOnlineError,
  modaArticolo,
  modaArticoloLoading,
  modaArticoloError,
  prestashopReport,
  prestashopReportLoading,
  prestashopReportError,
  formatLabel,
  formatValue,
  modaHiddenKeys,
}) {
  const [section, setSection] = useState("prestashop-vig");

  return (
    <section className="modificaProdottiPagina modificaProdottiDatiAltrove">
      <nav className="modificaProdottiDatiAltroveNav" aria-label="Tipi di dati esterni">
        {SECTIONS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={
              section === item.id
                ? "modificaProdottiDatiAltroveNavItem modificaProdottiDatiAltroveNavItem--active"
                : "modificaProdottiDatiAltroveNavItem"
            }
            onClick={() => setSection(item.id)}
            aria-current={section === item.id ? "page" : undefined}
          >
            {item.label}
          </button>
        ))}
      </nav>
      <div className="modificaProdottiDatiAltroveContent pa3 sezioneConScroll">
        {section === "prestashop-vig" && (
          <TestiOnline
            data={prestashopOnline}
            loading={prestashopOnlineLoading}
            error={prestashopOnlineError}
            site="VIG"
            showSiteTabs={false}
          />
        )}
        {section === "prestashop-bot" && (
          <TestiOnline
            data={prestashopOnline}
            loading={prestashopOnlineLoading}
            error={prestashopOnlineError}
            site="BOT"
            showSiteTabs={false}
          />
        )}
        {section === "moda" && (
          <DataList
            data={modaArticolo}
            loading={modaArticoloLoading}
            error={modaArticoloError}
            emptyMessage="Nessun dato MODA trovato per questo prodotto."
            formatLabel={formatLabel}
            formatValue={formatValue}
            hiddenKeys={modaHiddenKeys}
          />
        )}
        {section === "tecnici-web" && (
          <DataList
            data={prestashopReport}
            loading={prestashopReportLoading}
            error={prestashopReportError}
            emptyMessage="Nessun dato tecnico web trovato per questo prodotto."
            formatLabel={formatLabel}
            formatValue={formatValue}
          />
        )}
      </div>
    </section>
  );
}

export default DatiAltrove;
